// removed by extract-text-webpack-plugin
module.exports = {"miniProgress":"antd-pro-charts--mini-progress-miniProgress","progressWrap":"antd-pro-charts--mini-progress-progressWrap","progress":"antd-pro-charts--mini-progress-progress","target":"antd-pro-charts--mini-progress-target"};


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/src/components/Charts/MiniProgress/index.less
// module id = 1053
// module chunks = 0